import { useEffect, useRef, useCallback } from "react";

const useIdleTimer = (onIdle, idleTime = 30 * 60 * 1000) => {
  const timeoutRef = useRef(null);
  const isIdleRef = useRef(false);

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    isIdleRef.current = false;

    timeoutRef.current = setTimeout(() => {
      isIdleRef.current = true;
      onIdle();
    }, idleTime);
  }, [onIdle, idleTime]);

  useEffect(() => {
    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];

    const handleActivity = () => {
      if (!isIdleRef.current) {
        resetTimer();
      }
    };

    events.forEach((event) => {
      document.addEventListener(event, handleActivity);
    });

    resetTimer();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach((event) => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, [resetTimer]);

  const pause = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  const resume = useCallback(() => {
    resetTimer();
  }, [resetTimer]);

  return { pause, resume };
};

export default useIdleTimer;